import React, { useState } from "react";
import ReactDOM from "react-dom";

import backend from "../../../backend";
import RoleSelector from "./RoleSelector";

const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewUserModal = ({ open, onCancel, onCreated }) => {
  const [email, setEmail]         = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName]   = useState("");
  const [roles, setRoles]         = useState([]);
  const [errors, setErrors]       = useState({});
  const [submitErr, setSubmitErr] = useState(null);
  const [saving, setSaving]       = useState(false);

  if (!open) return null;

  const reset = () => {
    setEmail("");
    setFirstName("");
    setLastName("");
    setRoles([]);
    setErrors({});
    setSubmitErr(null);
  };

  const validate = () => {
    const e = {};
    if (!email.trim())              e.email = "Email requerido";
    else if (!EMAIL_RX.test(email)) e.email = "Email inválido";
    if (!firstName.trim())          e.firstName = "Nombre requerido";
    if (!lastName.trim())           e.lastName  = "Apellido requerido";
    if (roles.length === 0)         e.roles     = "Seleccioná al menos un rol";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const submit = async () => {
    setSubmitErr(null);
    if (!validate()) return;
    setSaving(true);
    try {
      const r = await backend.post("user/", {
        email: email.trim(),
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        roles,
      });
      reset();
      onCreated?.(r.data);
    } catch (err) {
      setSubmitErr(err?.response?.data?.error || err?.response?.data || err.message);
    } finally {
      setSaving(false);
    }
  };

  const cancel = () => {
    reset();
    onCancel?.();
  };

  return ReactDOM.createPortal(
    <div
      className="bini-modal-overlay"
      onClick={e => { if (e.target === e.currentTarget) cancel(); }}
    >
      <div className="bini-modal" role="dialog" aria-modal="true" style={{ width: 480 }}>
        <div className="bini-modal-title">Nuevo usuario</div>

        <div className="bini-field">
          <label>Email</label>
          <input
            className={`bini-input${errors.email ? " is-error" : ""}`}
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="usuario@empresa.cl"
            autoFocus
          />
          {errors.email && <div className="bini-field-error">{errors.email}</div>}
        </div>

        <div className="grid" style={{ gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          <div className="bini-field">
            <label>Nombre</label>
            <input
              className={`bini-input${errors.firstName ? " is-error" : ""}`}
              value={firstName}
              onChange={e => setFirstName(e.target.value)}
            />
            {errors.firstName && <div className="bini-field-error">{errors.firstName}</div>}
          </div>
          <div className="bini-field">
            <label>Apellido</label>
            <input
              className={`bini-input${errors.lastName ? " is-error" : ""}`}
              value={lastName}
              onChange={e => setLastName(e.target.value)}
            />
            {errors.lastName && <div className="bini-field-error">{errors.lastName}</div>}
          </div>
        </div>

        <div className="bini-field">
          <label>Roles</label>
          <RoleSelector value={roles} onChange={setRoles} disabled={saving} />
          {errors.roles && <div className="bini-field-error">{errors.roles}</div>}
        </div>

        {submitErr && (
          <div className="bini-warning">
            <div className="t">⚠ Error al crear usuario</div>
            <div className="d">{String(submitErr)}</div>
          </div>
        )}

        <div className="bini-modal-actions">
          <button className="bini-btn bini-btn-cancel" onClick={cancel} disabled={saving}>
            Cancelar
          </button>
          <button className="bini-btn bini-btn-save" onClick={submit} disabled={saving}>
            {saving ? "Creando…" : "Crear usuario"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default NewUserModal;
